<template>
  <Modal v-model="model" title="新增站点游戏" >
    <table
        class="TB_COLLAPSE"
        width="100%"
      >
        <thead>
          <th colspan="2">新增站点游戏</th>
        </thead>
        <tbody>
          <tr>
            <th>選擇彩种游戏</th>
            <td>
              <Select
               filterable
                v-model="form.newgameid"
                style="width: 200px"
              >
                <Option
                  v-for="(it, key) in newGameList"
                  :value="it.gameid"
                  :key="it.gameid"
                >{{ it.gamename }}</Option>
              </Select>
            </td>
          </tr>
          <tr>
              <th>参考彩种游戏</th>
            <td>
              <Select
               filterable
                v-model="form.refergameid"
                style="width: 200px"
              >
                <Option
                  v-for="(it, key) in refergameList"
                  :value="it.id"
                  :key="`${it.id}-${it.gameGroupId}`"
                >{{ it.gamename }}</Option>
              </Select>
            </td>
          </tr>
          <tr>
            <th>开启/关闭</th>
            <td>
              <RadioGroup v-model="form.upidop">
            <Radio :label="1" >开启</Radio>
            <Radio :label="0" >关闭</Radio>
          </RadioGroup>
            </td>
          </tr>
        </tbody>
    </table>
    <div slot="footer">
      <Button type="primary" @click="addGame" :loading="loading">新增</Button>
    </div>
  </Modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ModalAddSiteGame',
  props: {
    state: Boolean,
    memgamelist: Array
  },
  data() {
    return {
      form: {
        newgameid: null,
        refergameid: null,
        upidop: 0
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(['getAllGame', 'getmember']),
    model: {
      get () {
        return this.state
      },
      set (value) {
        this.resetFrom()
        this.$emit('update:state', value)
      }
    },
    newGameList () {
      if (!this.getAllGame.length) return []
      return this.getAllGame.filter(it => it.siteId == this.$route.query.siteClass || it.siteId == 0)
    },
    newGame () {
      if (this.form.newgameid == null) return {}
      return this.newGameList.find(it => it.gameid == this.form.newgameid)
    },
    refergameList () {
      if ('gameGroupId' in this.newGame === false) return []
      return this.memgamelist.filter(it => it.gameGroupId == this.newGame.gameGroupId )
    }
  },
  methods: {
    async addGame () {
      this.loading = true
      if (!this.form.newgameid) return this.$Message.warning('請選擇 彩种游戏');
      if (!this.form.refergameid) return this.$Message.warning('請選擇 参考彩种游戏');
      try {
        const data = {
          ...this.form,
          loid: this.getmember.pid,
          mid: Number(this.$route.query.siteid)
        }
        const res = await this.$axios.acount.memaddgame(data)
        if(res.status === 1) {
          this.$Message.success('新增成功');
          this.model = false
          this.$emit('repull')
        } else {
           this.$Message.error(res.msg);
        }
        setTimeout(() => {
          this.loading = false
        }, 1000);
      } catch (error) {
        this.$Message.error('網路異常');
        this.loading = false
      }
    },
    resetFrom () {
      this.form.newgameid = null
      this.form.refergameid = null
      this.form.upidop = 0
    }
  }
}
</script>